import React from 'react'
import { arrayOf, object } from 'prop-types'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config
const aptReportAssetsPath = `${assetsUrl}/assets/img/aptitude/report`

const AptitudeMajor = ({ majors }) => (
  <div className="aptitude-major">
    <SectionContainer
      paddingTop={80}
      paddingBottom={80}
      backgroundColor="transparent"
    >
      <Container className="aptitude-report__title">
        <Relazsizes
          dataSrc={`${aptReportAssetsPath}/major.png`}
          alt="Jurusan"
        />
        <div>
          <Typography component="h2" variant="title" className="text-variant-title-sm m-b-sm">JURUSAN apa saja yang sesuai dengan kepribadianmu?</Typography>
          <Typography component="p" variant="subbody">Berikut adalah 10 rekomendasi jurusan yang bisa kamu pilih berdasarkan hasil tes yang telah kamu lakukan:</Typography>
        </div>
      </Container>
      <ThumbnailSlider>
        {
          majors.map((major, idx) => (
            <div key={major.id} className="col-md-4 col-sm-6 col-xs-12">
              <CampusPerfectCard
                dataTestId={`rec-major-card-${idx}`}
                category={major.parentName}
                description={major.description}
                href={major.path}
                kind="studyFields"
                icon="common-course"
                likeable
                likeStatus={major.liked}
                likeTarget={major.id}
                logo={major.logo}
                title={major.name}
                thumbnail={major.thumbnail}
                withFooter
                openNewTab
              />
            </div>
          ))
        }
      </ThumbnailSlider>
      <Container>
        <Typography component="p" variant="caption" className="text-center">Cari tahu informasi mengenai jurusan tersebut secara lebih mendalam di halaman <a href="/majors" target="_blank"><b>campus.quipper.com/majors</b></a> untuk mendapatkan informasi mengenai gambaran jurusan, pengetahuan dan keahlian yang sesuai, kelebihan dari jurusan tersebut, peluang karier setelah lulus, kampus rekomendasi, hingga informasi dunia perkuliahan dan testimoni mahasiswa.</Typography>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .aptitude-major {
          background-image: url(${aptReportAssetsPath}/path-green.png);
          background-repeat: no-repeat;
          background-position: bottom center;
          background-size: contain;
          :global(.ThumbnailSlider) {
            margin: 0;
          }
          :global(p) {
            color: #0c2846 !important;
          }
          @media screen and (max-width: 767px) {
            background-size: auto;
          }
        }
      `}
    </style>
  </div>
)

AptitudeMajor.propTypes = {
  majors: arrayOf(object),
}

export default AptitudeMajor
